<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.7826 6.78261C12.7826 6.35039 12.4322 6 12 6C11.5678 6 11.2174 6.35039 11.2174 6.78261V11.2174H6.78261C6.35039 11.2174 6 11.5678 6 12C6 12.4322 6.35039 12.7826 6.78261 12.7826H11.2174V17.2174C11.2174 17.6496 11.5678 18 12 18C12.4322 18 12.7826 17.6496 12.7826 17.2174V12.7826H17.2174C17.6496 12.7826 18 12.4322 18 12C18 11.5678 17.6496 11.2174 17.2174 11.2174H12.7826V6.78261Z"
      fill="currentColor"
    />
  </svg>
</template>